export const AUDIO_LEVELS = Object.freeze({
  // TTS used to rely on the browser default volume (1.0), while SFX used a
  // separate hard-coded master gain. Keep both values together so they can be
  // tuned as one mix instead of drifting apart again.
  tts: 0.8,
  sfxMaster: 1.4,
  sfxDuck: 0.84,
});
